import script from "./ClientCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCard.vue?vue&type=script&setup=true&lang=js"

import "./ClientCard.vue?vue&type=style&index=0&id=56f342a0&lang=scss"

const __exports__ = script;

export default __exports__